var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.75C21.41 7.75 21.75 7.41 21.75 7V6C21.75 1.59 20.41 0.25 16 0.25H9.75V2.5C9.75 2.91 9.41 3.25 9 3.25C8.59 3.25 8.25 2.91 8.25 2.5V0.25H6C1.59 0.25 0.25 1.59 0.25 6V6.5C0.25 6.91 0.59 7.25 1 7.25C1.96 7.25 2.75 8.04 2.75 9C2.75 9.96 1.96 10.75 1 10.75C0.59 10.75 0.25 11.09 0.25 11.5V12C0.25 16.41 1.59 17.75 6 17.75H8.25V15.5C8.25 15.09 8.59 14.75 9 14.75C9.41 14.75 9.75 15.09 9.75 15.5V17.75H16C20.41 17.75 21.75 16.41 21.75 12C21.75 11.59 21.41 11.25 21 11.25C20.04 11.25 19.25 10.46 19.25 9.5C19.25 8.54 20.04 7.75 21 7.75ZM9.75 11.17C9.75 11.58 9.41 11.92 9 11.92C8.59 11.92 8.25 11.58 8.25 11.17V6.83C8.25 6.42 8.59 6.08 9 6.08C9.41 6.08 9.75 6.42 9.75 6.83V11.17Z",
    fill: "#6953D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorx);
export default __webpack_public_path__ + "static/media/Vector@x.8fa6c9b9bb3e0a1f3d7cc1ca7d7da5c9.svg";
export { ForwardRef as ReactComponent };